import { render } from "./ResumeProfile.vue?vue&type=template&id=36d057d8&scoped=true"
import script from "./ResumeProfile.vue?vue&type=script&lang=js"
export * from "./ResumeProfile.vue?vue&type=script&lang=js"

import "./ResumeProfile.vue?vue&type=style&index=0&id=36d057d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d057d8"]])

export default __exports__